import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Alert, Badge, Spinner } from "react-bootstrap";
import { api } from "../../services/api";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

function ModalNovoChamado({ loja, show, onHide, onSuccess, chamadoOrigem = null }) {
    const [setores, setSetores] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const chapa = localStorage.getItem("chapa");

    const [form, setForm] = useState({
        loja: "",
        setor: "",
        categoria: "",
        assunto: "",
        descricao: "",
        local: "",
        numero_serie: ""
    });

    const [arquivos, setArquivos] = useState([]);
    const [erro, setErro] = useState("");
    const [enviando, setEnviando] = useState(false);

    const removerAnexo = (indexParaRemover) => {
        setArquivos(prev => prev.filter((_, index) => index !== indexParaRemover));
    };

    const handleCategoriaChange = (e) => {
        const catId = e.target.value;
        const catObj = categorias.find(c => String(c.id_categoria || c.ID_CATEGORIA) === String(catId));

        setForm(prev => ({
            ...prev,
            categoria: catId,
            numero_serie: (catObj?.serie || catObj?.SERIE) === 'S' ? prev.numero_serie : ""
        }));
    };
    const categoriaAtual = categorias.find(c => String(c.id_categoria || c.ID_CATEGORIA) === String(form.categoria));
    const exigeSerie = (categoriaAtual?.serie || categoriaAtual?.SERIE) === 'S';

    const limparFormulario = () => {
        setForm({
            loja: "",
            setor: "",
            categoria: "",
            assunto: "",
            descricao: "",
            local: "",
            numero_serie: ""
        });
        setArquivos([]);
        setCategorias([]);
        setErro("");
        setEnviando(false);
    };

    useEffect(() => {
        if (show) {
            limparFormulario();
            carregarSetores();

            if (chamadoOrigem) {
                const idSetorOrigem = chamadoOrigem.id_setor || chamadoOrigem.ID_SETOR || "";
                setForm({
                    loja: loja,
                    setor: idSetorOrigem,
                    categoria: chamadoOrigem.id_categoria || chamadoOrigem.ID_CATEGORIA || "",
                    assunto: `[RECORRÊNCIA] ${chamadoOrigem.assunto || chamadoOrigem.ASSUNTO || ""}`,
                    descricao: "",
                    local: chamadoOrigem.local_exato || chamadoOrigem.LOCAL_EXATO || "",
                    numero_serie: chamadoOrigem.numero_serie || chamadoOrigem.NUMERO_SERIE || ""
                });
                if (idSetorOrigem) {
                    carregarCategorias(idSetorOrigem);
                }
            } else {
                setForm(prev => ({ ...prev, loja: loja }));
            }
        }
    }, [show, loja, chamadoOrigem]);

    const carregarSetores = async () => {
        try {
            const res = await api.get("/chamados/setores");
            setSetores(res.data || []);
        } catch (e) {
            setErro("Erro ao carregar setores");
        }
    };

    const carregarCategorias = async (idSetor) => {
        try {
            const res = await api.get(`/chamados/categorias?setor=${idSetor}`);
            setCategorias(res.data || []);
        } catch (e) {
            setErro("Erro ao carregar categorias");
        }
    };

    const handleSetor = (e) => {
        const value = e.target.value;
        setForm({ ...form, setor: value, categoria: "" });
        if (value) {
            carregarCategorias(value);
        } else {
            setCategorias([]);
        }
    };

    const handleFiles = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'text/plain'];

        let arquivosValidos = [];
        let erroTipo = false;

        selectedFiles.forEach(file => {
            if (allowedTypes.includes(file.type)) {
                arquivosValidos.push(file);
            } else {
                erroTipo = true;
            }
        });

        if (erroTipo) {
            toast.error("Apenas imagens (JPG/PNG), PDF ou TXT são permitidos.");
        }

        setArquivos(prev => {
            const total = [...prev, ...arquivosValidos];
            if (total.length > 3) {
                toast.warning("Limite máximo de 3 arquivos.");
                return total.slice(0, 3);
            }
            return total;
        });

        e.target.value = null;
    };

    const salvar = async () => {
        if (!form.loja || String(form.loja).trim() === "") {
            setErro("O campo LOJA é obrigatório.");
            return;
        }

        if (!chapa || chapa.trim() === "") {
            setErro("Erro de autenticação: CHAPA não encontrada. Faça login novamente.");
            toast.error("Usuário não identificado.");
            return;
        }

        if (!form.setor || !form.categoria || !form.assunto.trim() || !form.descricao.trim()) {
            setErro("Por favor, preencha todos os campos obrigatórios (Setor, Categoria, Assunto e Descrição).");
            return;
        }

        setErro("");
        setEnviando(true);

        try {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]);
                reader.onerror = error => reject(error);
            });

            const anexosPromessas = arquivos.map(async (file) => ({
                nome: file.name,
                base64: await toBase64(file)
            }));

            const anexosBase64 = await Promise.all(anexosPromessas);

            const payload = {
                loja: parseInt(form.loja),
                id_setor: parseInt(form.setor),
                id_categoria: parseInt(form.categoria),
                assunto: form.assunto.trim(),
                descricao: form.descricao.trim(),
                local: form.local.trim(),
                numero_serie: form.numero_serie ? form.numero_serie.trim().toUpperCase() : null,
                id_chamado_origem: chamadoOrigem ? (chamadoOrigem.id_chamado || chamadoOrigem.ID_CHAMADO) : null,
                usuario: chapa,
                anexos: anexosBase64
            };

            const res = await api.post('/chamado', payload);

            if (res.status === 201 || res.status === 200) {
                Swal.fire({
                    title: "Sucesso!",
                    text: chamadoOrigem ? "Chamado recorrente aberto com sucesso!" : "Chamado aberto com sucesso!",
                    icon: "success",
                    confirmButtonColor: '#8b0000'
                }).then((result) => {
                    if (result.isConfirmed && onSuccess) onSuccess();
                });
            }
        } catch (err) {
            console.error(err);
            Swal.fire({ title: "Erro!", text: "Erro ao gravar chamado.", icon: "error" });
            setEnviando(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={enviando ? null : onHide}
            size="lg"
            centered
            className="modal-fullscreen-mobile"
            backdrop="static"
        >
            <Modal.Header closeButton={!enviando} style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                <Modal.Title className="fs-6 fw-bold text-white">
                    {chamadoOrigem ? "Abrir Chamado Recorrente" : "Novo Chamado"}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="bg-light p-3">
                {erro && <Alert variant="danger" className="py-2 small">{erro}</Alert>}

                {chamadoOrigem && (
                    <Alert variant="warning" className="small py-2 mb-3 border-warning">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        Abertura de <strong>Recorrência / Ligação</strong> vinculada ao Chamado Original <strong>#{chamadoOrigem.id_chamado || chamadoOrigem.ID_CHAMADO}</strong>.
                    </Alert>
                )}

                <Form>
                    <Row className="g-2">
                        <Col xs={4} md={2}>
                            <Form.Group>
                                <Form.Label className="small fw-bold text-secondary mb-1">Loja</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={form.loja}
                                    disabled={true}
                                />
                            </Form.Group>
                        </Col>

                        <Col xs={8} md={5}>
                            <Form.Group>
                                <Form.Label className="small fw-bold text-secondary mb-1">Setor *</Form.Label>
                                <Form.Select size="sm" value={form.setor} onChange={handleSetor}>
                                    <option value="">Selecione</option>
                                    {setores.map(s => (
                                        <option key={s.id_setor || s.ID_SETOR} value={s.id_setor || s.ID_SETOR}>
                                            {s.nome_setor || s.NOME_SETOR}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col xs={12} md={5}>
                            <Form.Group>
                                <Form.Label className="small fw-bold text-secondary mb-1">Categoria *</Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={form.categoria}
                                    onChange={(e) => setForm({ ...form, categoria: e.target.value })}
                                    disabled={!form.setor}
                                >
                                    <option value="">Selecione</option>
                                    {categorias.map(c => (
                                        <option key={c.id_categoria || c.ID_CATEGORIA} value={c.id_categoria || c.ID_CATEGORIA}>
                                            {c.descricao || c.DESCRICAO}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mt-3">
                        <Form.Label className="small fw-bold text-secondary mb-1">Assunto *</Form.Label>
                        <Form.Control
                            size="sm"
                            value={form.assunto}
                            onChange={(e) => setForm({ ...form, assunto: e.target.value })}
                            placeholder="Resumo do problema..."
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label className="small fw-bold text-secondary mb-1">Descrição Detalhada *</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            size="sm"
                            value={form.descricao}
                            onChange={(e) => setForm({ ...form, descricao: e.target.value })}
                            placeholder="Descreva o problema com detalhes..."
                        />
                    </Form.Group>

                    <Row className="mt-3 g-2">
                        <Col xs={exigeSerie ? 6 : 12}>
                            <Form.Group>
                                <Form.Label className="small fw-bold text-secondary mb-1">Local Exato</Form.Label>
                                <Form.Control
                                    size="sm"
                                    value={form.local}
                                    onChange={(e) => setForm({ ...form, local: e.target.value })}
                                    placeholder="Ex: Caixa 02, Salão..."
                                />
                            </Form.Group>
                        </Col>

                        {exigeSerie && (
                            <Col xs={6}>
                                <Form.Group>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Nº Série / Patrimônio *</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        value={form.numero_serie}
                                        onChange={(e) => setForm({ ...form, numero_serie: e.target.value.toUpperCase() })}
                                        placeholder="Ex: SN-98765"
                                        style={{ textTransform: 'uppercase' }}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        )}
                    </Row>

                    {arquivos.length > 0 && (
                        <div className="d-flex flex-wrap gap-2 mt-3 p-2 bg-white rounded border">
                            {arquivos.map((file, index) => (
                                <Badge
                                    key={index}
                                    style={{ backgroundColor: '#8b0000' }}
                                    className="d-flex align-items-center p-2 rounded-pill shadow-sm"
                                >
                                    <i className="bi bi-paperclip me-1"></i>
                                    <span className="text-truncate" style={{ maxWidth: '120px' }}>
                                        {file.name}
                                    </span>
                                    <i
                                        className="bi bi-x-circle-fill ms-2"
                                        style={{ cursor: 'pointer', color: 'rgba(255,255,255,0.8)' }}
                                        onClick={() => removerAnexo(index)}
                                    ></i>
                                </Badge>
                            ))}
                        </div>
                    )}

                    <Form.Group className="mt-3">
                        <Form.Label className="small fw-bold text-secondary mb-1">Anexos (PDF - Imagem - TXT - máx 3)</Form.Label>
                        <Form.Control
                            type="file"
                            size="sm"
                            multiple
                            accept="image/*,.pdf,.txt"
                            onChange={handleFiles}
                            disabled={arquivos.length >= 3}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <div className="modal-footer-mobile-fixed bg-white border-top py-2 px-3 d-flex justify-content-end gap-2">
                <Button
                    variant="secondary"
                    size="sm"
                    className="fw-semibold"
                    onClick={onHide}
                    disabled={enviando}
                >
                    Cancelar
                </Button>
                <Button
                    style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                    size="sm"
                    className="fw-bold px-3"
                    onClick={salvar}
                    disabled={enviando}
                >
                    {enviando ? (
                        <>
                            <Spinner size="sm" animation="border" className="me-2" />
                            Salvando...
                        </>
                    ) : (
                        "Salvar Chamado"
                    )}
                </Button>
            </div>
        </Modal>
    );
}

export default ModalNovoChamado;